import { render, staticRenderFns } from "./building.vue?vue&type=template&id=9d582a9e&scoped=true"
import script from "./building.vue?vue&type=script&lang=js"
export * from "./building.vue?vue&type=script&lang=js"
import style0 from "./building.vue?vue&type=style&index=0&id=9d582a9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d582a9e",
  null
  
)

export default component.exports